// @flow
import { CategoriasRutaActionTypes } from './constants';

type CategoriasRutaAction = { type: string, payload: {} | string };

// common success
export const categoriasRutaApiResponseSuccess = (actionType: string, data: any): CategoriasRutaAction => ({
    type: CategoriasRutaActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const categoriasRutaApiResponseError = (actionType: string, error: string): CategoriasRutaAction => ({
    type: CategoriasRutaActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getCategoriaRuta = (id: string): CategoriasRutaAction => ({
    type: CategoriasRutaActionTypes.GET_CATEGORIA_RUTA,
    payload: { id },
});

export const addCategoriaRuta = (categoriaRuta:any):CategoriasRutaAction=>({
    type:CategoriasRutaActionTypes.ADD_CATEGORIA_RUTA,
    payload:categoriaRuta
})
export const updateCategoriaRuta = (categoriaRuta:any):CategoriasRutaAction=>({
    type:CategoriasRutaActionTypes.UPDATE_CATEGORIA_RUTA,
    payload:categoriaRuta
})
export const deleteCategoriaRuta = (id:string):CategoriasRutaAction=>({
    type:CategoriasRutaActionTypes.DELETE_CATEGORIA_RUTA,
    payload:{id}
})

export const listCategoriasRuta = (params:any): CategoriasRutaAction => ({
    type: CategoriasRutaActionTypes.LIST_CATEGORIAS_RUTA,
    payload: params,
});


export const resetCategoriasRuta = (): CategoriasRutaAction => ({
    type: CategoriasRutaActionTypes.RESET,
    payload: {},
});

